export const ERRORS = {
  couldNotUpdateProjects: 'Could not update projects',
  couldNotUpdateLinkedPullRequests: 'Could not update linked pull requests',
  couldNotUpdateLinkedBranches: 'Could not update linked branches',
  couldNotUpdateIssueTitle: 'Could not update issue title',
  couldNotStartTransfer: 'Could not initiate issue transfer',
  issueTypeUpdateError: 'Something went wrong, could not set the issue type. Please reload and try again.',
  issueTypeUpdateErrorReporting: (message: string) => `Changing issue type failed with error:${message}`,
}
